import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { ArticleListService } from '../../services/article-list.service';
import { ArtigosPaginados } from './../../classes/artigos-paginados';

@Component({
  selector: 'app-article-list',
  templateUrl: './article-list.component.html',
  styleUrls: ['./article-list.component.css'],
  standalone: false,
})
export class ArticleListComponent {
  paginatedArticles: ArtigosPaginados;
  tag: string;
  pageHeader = { title: '', style: 'paddingHeader' };
  count;
  page = 1;
  pageSize = 10;
  isLoading = true;

  constructor(
    private articleListService: ArticleListService,
    private actRoute: ActivatedRoute,
    private viewportScroller: ViewportScroller,
  ) {
    this.actRoute.queryParams.subscribe((params) => {
      this.isLoading = true;
      this.tag = params['s'];
      this.iniciaComponente();
    });
  }

  private iniciaComponente(): void {
    this.getArticleList();
    setTimeout(() => {
      this.viewportScroller.scrollToPosition([0, 0]);
    }, 0);
  }

  async getArticleList(): Promise<void> {
    this.paginatedArticles = await firstValueFrom(
    this.articleListService.getArticleList(this.tag, this.page, this.pageSize),
    );
    if (this.paginatedArticles.artigos.length == 0) {
      this.notFound();
    }
    this.isLoading = false;
    this.count = this.paginatedArticles.tamanho;
  }

  notFound() {
    this.paginatedArticles = {
      artigos: [
        {
          id: 0,
          titulo: 'Nenhum resultado encontrado.',
          conteudo: '',
          resumo: '',
          META: { titulo: '', descricao: '' },
          categoria: '',
          idioma: '',
          marcadores: [],
          data_criacao: '',
          data_atualizacao: '',
          relacionados: [],
        },
      ],
      tamanho: 0,
    };
    this.count = 0;
  }

  handlePageChange(event) {
    const newPageSize = event.rows;
    if (newPageSize !== this.pageSize) {
      this.page = 1;
    } else {
      this.page = Math.floor(event.first / event.rows) + 1;
    }
    this.pageSize = newPageSize;
    this.getArticleList();
    setTimeout(() => {
      this.viewportScroller.scrollToPosition([0, 0]);
    }, 0);
  }
}
